/* Pattern for ad hoc query against relay store */
import graphql from 'babel-plugin-relay/macro';
import { fetchQuery } from 'react-relay';
import AbEnvironment from '../auth/AbEnvironment';

const abEnvironment = new AbEnvironment();
      
const query = graphql`
query VendorStatementLinesFetchQuery($vAccountId: UUID, $startDate: Datetime, $endDate: Datetime, $first: Int, $offset: Int) {
  getvendorstatementlines(vaccountid: $vAccountId, startts: $startDate, endts: $endDate, first: $first, offset: $offset) {
    totalCount
    nodes {
      beginningBalance
      paymentIn
      receivedIn
      chargeOut
      payoutOut
      endingBalance
      rowPurpose
      billTransactionId
      billTransactionTime
      billTransactionType
      recvTransactionId
      recvTransactionTime
      recvTransactionType
      revTransactionId
      revTransactionTime
      revTransactionType
      resellerAccountId
      resellerAccountName
      resellerPId
      resellerProgramName
      vendorPayoutId
      vendorPayoutStart
      vendorPayoutEnd
      vendorPayoutStatus
      payoutAmount
      feeAmount
      vendorBillTotal
      vendorConfAmount
      vendorRevAmount
      balance
    }
  }
}
`;

function fetch(vAccountId, startDate, endDate, first, offset) {
  const variables = {
    vAccountId: vAccountId, 
    startDate: startDate,
    endDate: endDate,
    first: first,
    offset: offset
  }
    
  return fetchQuery(
      abEnvironment.getEnvironment(),
      query,
      variables
  );
}
/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */ 
export default { fetch };